import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import EmergencyModal from './EmergencyModal';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiAlertTriangle } = FiIcons;

function Footer() {
  const [isEmergencyOpen, setIsEmergencyOpen] = useState(false);

  return (
    <>
      <EmergencyModal isOpen={isEmergencyOpen} onClose={() => setIsEmergencyOpen(false)} />
      
      <footer className="bg-mk-teal-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-4 mb-4">
                <img 
                  src="https://wasacon.de/logo_mk_ausbau.png" 
                  alt="MK-AUSBAU Logo" 
                  className="h-10 w-auto filter brightness-0 invert" 
                />
              </div>
              <p className="text-mk-teal-200 text-sm leading-relaxed">
                Ihr zuverlässiger Partner für professionellen Innenausbau und hochwertige Sanierungsarbeiten. Qualität und Präzision seit Jahren.
              </p>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
              <div className="space-y-3">
                <a 
                  href="tel:+4924528607038" 
                  className="flex items-center space-x-3 text-mk-teal-200 hover:text-white transition-colors group"
                >
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-mk-teal-300 group-hover:text-white transition-colors" />
                  <span>+49 (0) 2452 8607038</span>
                </a>
                <a 
                  href="mailto:info@ausbau.nrw" 
                  className="flex items-center space-x-3 text-mk-teal-200 hover:text-white transition-colors group"
                >
                  <SafeIcon icon={FiMail} className="w-5 h-5 text-mk-teal-300 group-hover:text-white transition-colors" />
                  <span>info@ausbau.nrw</span>
                </a>
                <a 
                  href="https://www.google.com/maps/dir//Am+Diebsweg+17,+52525+Heinsberg/@51.040924,6.0892095,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47c0af825f62c6a1:0x3902b563a6cb20b0!2m2!1d6.1716098!2d51.040953?hl=de&authuser=0&entry=ttu&g_ep=EgoyMDI1MDgxOC4wIKXMDSoASAFQAw%3D%3D" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-mk-teal-200 hover:text-white transition-colors group"
                >
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-mk-teal-300 group-hover:text-white transition-colors" />
                  <span>Am Diebsweg 17, 52525 Heinsberg</span>
                </a>
                
                {/* Notfall Button im Footer (Desktop & Mobile sichtbar) */}
                <button
                  onClick={() => setIsEmergencyOpen(true)}
                  className="flex items-center space-x-3 text-mk-red-300 hover:text-mk-red-100 transition-colors group mt-4 pt-4 border-t border-mk-teal-700 w-full text-left"
                >
                  <SafeIcon icon={FiAlertTriangle} className="w-5 h-5 text-mk-red-400 group-hover:text-mk-red-200 transition-colors" />
                  <span className="font-semibold uppercase tracking-wider text-xs">Notfallkontakt öffnen</span>
                </button>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <div className="space-y-2">
                <Link 
                  to="/ueber" 
                  className="block text-mk-teal-200 hover:text-white transition-colors"
                >
                  Über uns
                </Link>
                <Link 
                  to="/services" 
                  className="block text-mk-teal-200 hover:text-white transition-colors"
                >
                  Dienstleistungen
                </Link>
                <Link 
                  to="/portfolio" 
                  className="block text-mk-teal-200 hover:text-white transition-colors"
                >
                  Portfolio
                </Link>
                <Link 
                  to="/kontakt" 
                  className="block text-mk-teal-200 hover:text-white transition-colors"
                >
                  Kontakt
                </Link>
                <Link 
                  to="/legal" 
                  className="block text-mk-teal-200 hover:text-white transition-colors"
                >
                  Impressum & Datenschutz
                </Link>
              </div>
            </div>
          </div>

          <div className="border-t border-mk-teal-700 mt-8 pt-8 text-center">
            <p className="text-mk-teal-300 text-sm">
              © 2025 MK-AUSBAU Innenausbau & Sanierung. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;